export type ActionPromiseControls = {
    resolve: (value?: unknown) => void;
    reject: (reason?: unknown) => void;
};

export type ModalActionSettlement = ActionPromiseControls & {
    /** Close the modal and resolve with null (user cancelled). */
    cancel: () => void;
    /** Close the modal and resolve with an optional value (success). */
    succeed: (value?: unknown) => void;
    /** Close the modal and reject with the given error. */
    fail: (error: unknown) => void;
};

/**
 * Helpers for modal-based Actions. Every Action promise must settle so callers
 * (e.g. HiddenActionsComponent) can clear in-flight UI state in `.finally()`.
 */
export const createModalActionSettlement = (
    destroyModal: () => void,
    controls: ActionPromiseControls
): ModalActionSettlement => ({
    ...controls,
    cancel: () => {
        destroyModal();
        controls.resolve(null);
    },
    succeed: (value?: unknown) => {
        destroyModal();
        controls.resolve(value);
    },
    fail: (error: unknown) => {
        destroyModal();
        controls.reject(error);
    },
});
